export const documents = {
  generatingDocument: 'Dokumentum generálása folyamatban...',
  generatingDocumentWithPdf: 'Dokumentum és PDF konverzió folyamatban...',
  generated: 'Dokumentum generálva',
  deleted: 'Dokumentum sikeresen törölve',
  generateDocument: 'Dokumentum generálása',
  selectType: 'Dokumentum típus kiválasztása',
  quotation: 'Árajánlat',
  contract: 'Szerződés',
  warranty: 'Garancia',
  customer: 'Ügyfél',
  quotationDescription: 'Árajánlat generálása ügyfelek számára',
  contractDescription: 'Szerződés generálása ügyfelek számára',
  warrantyDescription: 'Garanciajegy generálása',
  selectQuotation: 'Árajánlat kiválasztása',
  selectContract: 'Szerződés kiválasztása',
  selectWarranty: 'Garancia kiválasztása',
  selectCustomer: 'Ügyfél kiválasztása',
  selectBaseQuotation: 'Alapajánlat kiválasztása',
  selectBaseQuotationDescription: 'Válasszon egy meglévő ajánlatot az új dokumentum alapjaként',
  noQuotationsForCustomer: 'Nincs elérhető ajánlat ehhez az ügyfélhez',
  noWarrantyTemplates: 'Nincsenek garancia sablonok',
  noWarrantyTemplatesDescription: 'Először töltse fel a garanciajegy sablont a sablonok menüben.',
  noTemplatesAvailable: 'Nincs elérhető sablon ehhez a típushoz',
  skipQuotationSelection: 'Ajánlat kiválasztás kihagyása',
  selectDescription: '{{type}} kiválasztása',
  searchQuotation: 'Árajánlat keresése',
  searchCustomer: 'Ügyfél keresése',
  searchWarranty: 'Garancia keresése',
  createdAt: 'Létrehozva: {{date}}',
  taxNumber: 'Adószám: {{number}}',
  email: 'Email: {{email}}',
  status: '{{status}}',
  organization: 'Szervezet',
  individual: 'Magánszemély',
  noResults: 'Nincs találat a keresési feltételekre',
  noItemsAvailable: 'Nincs elérhető elem',
  tryDifferentKeywords: 'Próbáld meg más kulcsszavakkal',
  createNewItem: 'Hozz létre új elemet a folytatáshoz',
  pagination: {
    previous: 'Előző',
    next: 'Következő',
    page: '{{current}}/{{total}} oldal',
    showing: '{{from}}-{{to}}/{{total}} elem'
  },
  statuses: {
    draft: 'Piszkozat',
    valid: 'Érvényes',
    expired: 'Lejárt',
    success: 'Elfogadva',
    rejected: 'Elutasítva'
  },
  selectedDocument: 'Kiválasztott {{type}}',
  selectTemplate: 'Szerződés sablon kiválasztása',
  selectWarrantyTemplate: 'Garancia sablon kiválasztása',
  selectTemplateDescription: 'A kiválasztott szerződés sablon lesz használva a dokumentum generálásához',
  selectWarrantyTemplateDescription: 'A kiválasztott garancia sablon lesz használva a garanciajegy generálásához',
  templateSearchPlaceholder: 'Szerződés sablon keresése...',
  warrantyTemplateSearchPlaceholder: 'Garancia sablon keresése...',
  templatePreview: 'Szerződés sablon előnézet',
  warrantyTemplatePreview: 'Garancia sablon előnézet',
  selectedTemplate: 'Kiválasztott szerződés sablon',
  selectedWarrantyTemplate: 'Kiválasztott garancia sablon',
  fieldsInTemplate: '{{count}} mező a szerződés sablonban',
  fieldsInWarrantyTemplate: '{{count}} mező a garancia sablonban',
  additionalFields: 'További mezők',
  otherFields: 'További mezők',
  errors: {
    noTemplateSelected: 'Nincs kiválasztott szerződés sablon',
    noWarrantyTemplateSelected: 'Nincs kiválasztott garancia sablon',
    noDataAvailable: 'Nincs elérhető adat a dokumentum generálásához',
    generationError: 'Hiba történt a dokumentum generálása közben',
    warrantyGenerationError: 'Hiba történt a garanciajegy generálása közben'
  },
  generatedDocumentSuccess: 'Dokumentum sikeresen létrehozva',
  generatedWarrantyDocumentSuccess: 'Garanciajegy sikeresen generálva',
  generatedDocumentError: 'Hiba történt a dokumentum generálása közben',
  generatedWarrantyDocumentError: 'Hiba történt a garanciajegy generálása közben',
  warrantyData: 'Garancia adatok',
  warrantyNumber: 'Garancia száma',
  warrantyType: 'Garancia típusa',
  warrantyStatus: 'Garancia státusz',
  productName: 'Termék neve',
  productCode: 'Termék kódja',
  manufacturer: 'Gyártó',
  model: 'Modell',
  serialNumber: 'Sorozatszám',
  batchNumber: 'Tételszám',
  customerName: 'Ügyfél neve',
  customerEmail: 'Ügyfél e-mail',
  supplierName: 'Szállító neve',
  warrantyStartDate: 'Garancia kezdete',
  warrantyEndDate: 'Garancia vége',
  purchaseDate: 'Vásárlás dátuma',
  warrantyDuration: 'Garancia időtartam',
  invoiceNumber: 'Számla száma',
  purchasePrice: 'Vásárlási ár',
  currency: 'Valutanem',
  warrantyTerms: 'Garancia feltételek',
  warrantyCoverage: 'Garancia lefedettség',
  warrantyExclusions: 'Garancia kizárások',
  notes: 'Megjegyzések',
  claimsCount: 'Garanciális esetek száma',
  generationDate: 'Generálás dátuma',
  preview: {
    loaded: 'Dokumentum betöltve',
    loading: 'Dokumentum betöltése...',
    error: 'Hiba történt a dokumentum betöltése közben',
    reload: 'Újratöltés...',
    download: 'Letöltés',
    browserCannotDisplay: 'A böngésző nem tudja megjeleníteni ezt a dokumentumot'
  },
  editValues: 'Értékek szerkesztése',
  filled: 'Kitöltött',
  searchField: 'Mező keresése...',
  field: 'Mező',
  value: 'Érték',
  closePreview: 'Előnézet bezárása',
  generatePreview: 'Előnézet generálása',
  regeneratePreview: 'Előnézet újragenerálása',
  clickToGeneratePreview: 'Kattints a generálásra a dokumentum előnézetének megjelenítéséhez',
  empty: 'Üres',
  customerData: 'Ügyféladatok',
  chooseOutputFormat: 'Kimeneti formátum kiválasztása',
  generating: 'Generálás folyamatban...',
  formatSetToDocx: 'Formátum beállítva: DOCX',
  formatSetToPdf: 'Formátum beállítva: DOCX és PDF',
  pdfNotImplemented: 'A PDF export jelenleg nem elérhető',
  documentModal: {
    title: '{{name}} dokumentumok',
    documentViewer: 'Dokumentumok megtekintése',
    noDocuments: 'Nincs elérhető dokumentum',
    noDocumentsDescription: 'Ehhez a tételhez még nem lett generálva vagy feltöltve dokumentum.',
    fileViewer: 'Kattintson a fájl megnyitásához',
    open: 'Megnyitás',
    openFile: 'Fájl megnyitása',
    search: 'Dokumentum keresése...',
    selectDocument: 'Dokumentum kiválasztása',
    noResults: 'Nincs találat a keresési feltételekre',
    unsupportedFileFormat: 'Nem támogatott fájlformátum',
    documentLoadError: 'Hiba történt a dokumentum betöltése közben',
    cannotPreviewThisFormat: 'Ezt a formátumot nem lehet előnézetben megjeleníteni',
    browserCannotDisplay: 'A böngésző nem tudja megjeleníteni ezt a dokumentumot',
  },
  templateType: 'Sablon típusa',
  searchTemplate: 'Sablon keresése...',
  templateCount: '{{count}} sablon található',
  noSearchResults: 'Nincs találat a keresésre',
  tryDifferentSearch: 'Próbáljon más keresési feltételeket',
  generationSuccess: 'Dokumentum sikeresen létrehozva',
  generationSuccessDescription: 'A dokumentum elkészült és készen áll a letöltésre',
  downloadDocument: 'Dokumentum letöltése',
  downloadDocuments: 'Dokumentumok letöltése',
  selectDocument: 'Válasszon dokumentumot a generáláshoz',
  podTableViewer: 'POD Adatok Megtekintése',
  viewPodTable: 'POD Adatok Megtekintése',
  noPodTableData: 'Nincsenek POD adatok',
  podAddress: 'Cím',
  measurementType: 'Mérés típusa',
  annualConsumption: 'Éves fogyasztás',
  viewRawData: 'Nyers XML adatok megtekintése',
  paymentDuePlaceholder: 'Adja meg a fizetési határidőt napokban'
}
